import React, { useState } from "react";
import SingularProject from "./SingularProject";
import CriterionSearch from "./CriterionSearch";
import './../styles/ProjectList.css';
import { loadProjectList, loadProjectLogo, loadProjectVideo } from '../scripts/FileLoader';
import { removeDuplicates } from "../scripts/Utils";
const ProjectList = function (props) {
    let projects = loadProjectList();
    let chosenFeatures = new class {
        constructor() {
            this.hasStar = null;
            this.programmingLanguage = null;
            this.tag = null;
            this.technology = null;
        }
    };
    let [getChosenFeatures, setChosenFeatures] = useState(() => chosenFeatures);
    return React.createElement("div", { className: "projectList" },
        React.createElement("h2", { className: "header" }, props.title),
        React.createElement("br", null),
        props.criterionSearch === undefined ? undefined :
            React.createElement(CriterionSearch, { setChosenFeatures: setChosenFeatures, visibleFeaturesSets: createVisibleFeatureSets(projects) }),
        projects
            .filter(project => projectsMeetsCriteria(project, getChosenFeatures))
            .map((project) => React.createElement(SingularProject, { title: project.title, description: project.description, image: loadProjectLogo(project.abreveation), video: loadProjectVideo(project.abreveation), features: project.features, key: project.abreveation }, React.createElement("p", { dangerouslySetInnerHTML: { __html: project.content } }))),
        React.createElement("br", null));
};
export default ProjectList;
function createVisibleFeatureSets(allProjects) {
    const uniqueStarStatuses = removeDuplicates(allProjects.map(project => project.features.hasStar));
    const uniqueTags = removeDuplicates(allProjects.flatMap(project => project.features.tags));
    const uniqueProgrammingLanguages = removeDuplicates(allProjects.flatMap(project => project.features.programmingLanguages));
    const uniqueTechnologies = removeDuplicates(allProjects.flatMap(project => project.features.technologies));
    const getFeatureWithoutProjectCount = (featureWithProjectCount) => featureWithProjectCount.lastIndexOf("(") == -1 ?
        null : featureWithProjectCount.substring(0, featureWithProjectCount.lastIndexOf("(") - 1);
    return [
        {
            name: "programming languages",
            settableOptions: uniqueProgrammingLanguages.map(language => language + " (" + allProjects.filter(project => project.features.programmingLanguages.includes(language)).length + ")"),
            setFeatures: (chosenFeatures, featureWithProjectCount) => {
                chosenFeatures.programmingLanguage = getFeatureWithoutProjectCount(featureWithProjectCount);
                return chosenFeatures;
            }
        },
        {
            name: "tags",
            settableOptions: uniqueTags.map(tag => tag + " (" + allProjects.filter(project => project.features.tags.includes(tag)).length + ")"),
            setFeatures: (chosenFeatures, featureWithProjectCount) => {
                chosenFeatures.tag = getFeatureWithoutProjectCount(featureWithProjectCount);
                return chosenFeatures;
            }
        },
        {
            name: "technologies",
            settableOptions: uniqueTechnologies.map(technology => technology + " (" + allProjects.filter(project => project.features.technologies.includes(technology)).length + ")"),
            setFeatures: (chosenFeatures, featureWithProjectCount) => {
                chosenFeatures.technology = getFeatureWithoutProjectCount(featureWithProjectCount);
                return chosenFeatures;
            }
        },
        {
            name: "star",
            settableOptions: uniqueStarStatuses.map(hasStar => (hasStar ? "⭐" : "") + " (" + allProjects.filter(project => project.features.hasStar == hasStar).length + ")"),
            setFeatures: (chosenFeatures, featureWithProjectCount) => {
                chosenFeatures.hasStar = featureWithProjectCount == "" ? null : Boolean(getFeatureWithoutProjectCount(featureWithProjectCount));
                return chosenFeatures;
            }
        }
    ];
}
function projectsMeetsCriteria(project, criteria) {
    return (criteria.programmingLanguage == null || project.features.programmingLanguages.includes(criteria.programmingLanguage)) &&
        (criteria.technology == null || project.features.technologies.includes(criteria.technology)) &&
        (criteria.tag == null || project.features.tags.includes(criteria.tag)) &&
        (criteria.hasStar == null || project.features.hasStar == criteria.hasStar);
}
